/**
 * Persistencia del orden manual de contactos (localStorage), por cuenta y sobrevive a logout normal.
 * Clave por usuario: `${STORAGE_KEYS.CONTACTS_MANUAL_PEER_ORDER}_${usuarioId}`.
 */

import { STORAGE_KEYS } from './constants';

export const CONTACTS_MANUAL_ORDER_LEGACY_KEY = STORAGE_KEYS.CONTACTS_MANUAL_PEER_ORDER;

/**
 * @param {unknown} viewerUserId
 * @returns {string|null}
 */
export function contactsManualOrderKeyForViewer(viewerUserId) {
  const id = Number(viewerUserId);
  if (!Number.isFinite(id) || id <= 0) return null;
  return `${CONTACTS_MANUAL_ORDER_LEGACY_KEY}_${id}`;
}

/**
 * @param {string|null|undefined} raw
 * @returns {string[]}
 */
export function parseManualPeerOrderJson(raw) {
  if (raw == null || String(raw).trim() === '') return [];
  try {
    const p = JSON.parse(raw);
    if (!Array.isArray(p)) return [];
    return p.map((x) => String(x).trim()).filter(Boolean);
  } catch {
    return [];
  }
}

/**
 * Lee orden para el usuario; si no hay clave por usuario pero sí legacy global, migra una vez.
 * @param {unknown} viewerUserId
 * @returns {string[]}
 */
export function loadManualPeerOrderForViewer(viewerUserId) {
  const userKey = contactsManualOrderKeyForViewer(viewerUserId);
  if (!userKey) return [];
  try {
    let raw = localStorage.getItem(userKey);
    if (raw == null || String(raw).trim() === '') {
      const legacy = localStorage.getItem(CONTACTS_MANUAL_ORDER_LEGACY_KEY);
      if (legacy != null && String(legacy).trim() !== '') {
        localStorage.setItem(userKey, legacy);
        localStorage.removeItem(CONTACTS_MANUAL_ORDER_LEGACY_KEY);
        raw = legacy;
      }
    }
    return parseManualPeerOrderJson(raw);
  } catch {
    return [];
  }
}

/**
 * @param {unknown} viewerUserId
 * @param {string[]} ids
 */
export function persistManualPeerOrderForViewer(viewerUserId, ids) {
  const userKey = contactsManualOrderKeyForViewer(viewerUserId);
  if (!userKey || !Array.isArray(ids)) return;
  try {
    localStorage.setItem(userKey, JSON.stringify(ids));
  } catch (_) {
    /* noop */
  }
}

/**
 * Copia todas las entradas de orden manual (legacy + por usuario) para reinyectar tras localStorage.clear().
 * @param {Storage} storage
 * @returns {Record<string, string>}
 */
export function snapshotContactsManualOrderEntries(storage) {
  if (!storage || typeof storage.length !== 'number') return {};
  const prefix = CONTACTS_MANUAL_ORDER_LEGACY_KEY;
  const out = {};
  try {
    for (let i = 0; i < storage.length; i += 1) {
      const k = storage.key(i);
      if (!k) continue;
      if (k === prefix || k.startsWith(`${prefix}_`)) {
        const v = storage.getItem(k);
        if (v != null) out[k] = v;
      }
    }
  } catch (_) {
    /* noop */
  }
  return out;
}

/**
 * @param {Storage} storage
 * @param {Record<string, string>} snapshot
 */
export function restoreContactsManualOrderEntries(storage, snapshot) {
  if (!storage || !snapshot || typeof snapshot !== 'object') return;
  try {
    Object.entries(snapshot).forEach(([k, v]) => {
      if (typeof k === 'string' && v != null) storage.setItem(k, String(v));
    });
  } catch (_) {
    /* noop */
  }
}
